import React, { FC } from "react";
import { Button, Modal } from "antd";

type PortalSubmitModalProps = {
    open: boolean;
    title: string;
    handleOk: () => void;
    handleCancel: () => void;
    handleSave: () => void;
    isLoading?: boolean;
}

const PortalSubmitModal: FC<PortalSubmitModalProps> = (props) => {
  return (
      <Modal
        open={props?.open}
        title={props?.title}
        onOk={props?.handleOk}
        onCancel={props?.handleCancel}
        footer={(_, { OkBtn, CancelBtn }) => (
          <>
            <Button onClick={props?.handleCancel}>
              No
            </Button>
            <Button
              onClick={props?.handleSave}
              loading={props?.isLoading}
            >
              Yes
            </Button>
          </>
        )}
        centered
      >
      </Modal>
  );
};

export default PortalSubmitModal;
